import { TableColumn } from "../../components/Table";
import React, { useCallback, useEffect } from "react";
import JobConfigView from "../../components/JobConfigView";
import { JobType } from "../../constants/JobTypes";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  fetchJobConfigCausalLoopRct,
  fetchJobRunCausalLoopRct,
} from "../../redux/causalLoopRctSlice";
import Loader from "../../components/Loader";

// Mirrors causal-loop/index.tsx exactly, scoped to JobType.CausalLoopRct.
const columns: TableColumn[] = [
  { key: "name", label: "Name" },
  {
    key: "createdDate",
    label: "Created Date",
    formatter: {
      type: "date",
    },
  },
  { key: "action", label: "Action" },
];

const causalLoopRctBreadCrumbs = [
  {
    name: "Home",
    url: "/",
  },
  {
    name: "Causal Loop - With RCT",
    url: "/causal-loop-rct/landing",
  },
];

const CausalLoopRctList: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { jobConfigList, jobRunList, loading } = useSelector(
    (state: RootState) => state.causalLoopRct
  );

  useEffect(() => {
    dispatch(fetchJobConfigCausalLoopRct());
    dispatch(fetchJobRunCausalLoopRct());
  }, [dispatch]);

  const handleRefresh = useCallback(() => {
    dispatch(fetchJobConfigCausalLoopRct());
    dispatch(fetchJobRunCausalLoopRct());
  }, [dispatch]);

  // Same in-flight polling pattern as causal-loop/index.tsx - see its comment
  // for why this polls jobRunList only, and only while a job is actually
  // running/pending.
  const hasInFlightJobs = jobRunList?.some(
    (run: any) => run.jobStatus === "RUNNING" || run.jobStatus === "PENDING"
  );
  useEffect(() => {
    if (!hasInFlightJobs) return;
    const interval = setInterval(() => dispatch(fetchJobRunCausalLoopRct()), 15000);
    return () => clearInterval(interval);
  }, [hasInFlightJobs, dispatch]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <JobConfigView
          jobConfigList={jobConfigList}
          jobRunList={jobRunList}
          breadCrumbs={causalLoopRctBreadCrumbs}
          jobType={JobType.CausalLoopRct}
          tableColumns={columns}
          onRefresh={handleRefresh}
        />
      )}
    </>
  );
};

export default CausalLoopRctList;
